<template>
    <div class="users-style">

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Settings<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings / Attendance Devices</span>
        </h4>


        <div class="px-3 py-4 ibox mt-4">

            <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
                <h4 class="clearfix mb-0">
                    <span class="float-left">Attendance Devices
                        <span class="title-sub-text"></span>
                    </span>
                    <span class="float-right"></span>
                </h4>
            </div>
            <div class="clearfix row py-2 mb-2 ">

                <div class="col-sm-6">  
                    <div class="custom-search w-100">
                        <b-input-group class="mb-0">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
                <div class="col-sm-6 float-right text-right">
                    <b-button id="show-btn" class="" @click="addNew(false)">+ Add Device</b-button>
                </div>
            </div>

            <div class="row justify-content-center pl-3 pr-3">
                <div class="col-sm-12  px-0">
                    <b-modal id="bv-modal-device" size="lg" hide-footer :title="modalTitle">
                        <b-overlay :show="showoverlay" rounded="sm">


                                <b-form autocomplete="off" @submit.stop.prevent="onSubmit">
                                    <div class="clearfix">
                                        <div class="px-3">
                                            <input type="hidden" v-model="fdata.id" name="id">

                                        <b-form-group label="Select Work Location" label-for="branch_id" class="w-100 required-field">
                                            <b-input-group>
                                                <b-form-select id="branch_id" name="branch_id" v-model="fdata.branch_id" :options="branches" v-validate="{required: true}" data-vv-as="Work Location"
                                                                class="w-100" aria-describedby="branch_id-feedback" :state="validateState('branch_id')">
                                                    <template #first>
                                                    <b-form-select-option disabled :value="null">Select Work Location</b-form-select-option>
                                                    </template>
                                                </b-form-select>
                                                <b-form-invalid-feedback id="branch_id-feedback" v-if="veeErrors.has('branch_id')">
                                                {{ veeErrors.first('branch_id') }}
                                                </b-form-invalid-feedback>
                                            </b-input-group>
                                            
                                        </b-form-group>

                                            <b-form-group  id="ip_address-group" label="IP Address" class="required-field" label-for="ip_address">
                                                <b-input-group>
                                                    <b-form-input id="ip_address" class="radius-8" name="ip_address" v-model="fdata.ip_address" v-validate="{ required: true, min: 3 }" :state="validateState('ip_address')" aria-describedby="ip_address-feedback" data-vv-as="IP Address"></b-form-input>


                                                    <b-form-invalid-feedback id="ip_address-feedback">{{ veeErrors.first('ip_address') }}</b-form-invalid-feedback>
                                                </b-input-group>
                                            </b-form-group>


                                            <b-form-group  id="port-group" label="Port" class="required-field" label-for="port">
                                                <b-input-group>
                                                    <b-form-input id="port" class="radius-8" autocomplete="new-password" name="port" v-model="fdata.port" v-validate="{ required: true, min: 4 }" :state="validateState('port')" aria-describedby="port-feedback" data-vv-as="Port"></b-form-input>
                                                    <b-form-invalid-feedback id="port-feedback">{{ veeErrors.first('port') }}</b-form-invalid-feedback>
                                                </b-input-group>
                                            </b-form-group>

                                            <b-form-group  id="password-group" label="Password" label-for="password">
                                                <b-input-group>
                                                    <b-form-input type="password" class="radius-8" autocomplete="new-password" id="password" name="password" v-model="fdata.password" v-validate="{ }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                                                    <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                                                </b-input-group>
                                            </b-form-group>

                                            <div class="full-width text-center my-4">
                                                <b-button type="submit" variant="primary" >{{ modalTitle == 'Edit Device' ? 'Update' : 'Save' }}</b-button>
                                                <b-button class="ml-2 custom-wizard-btn" @click="$bvModal.hide('bv-modal-device')" variant="primary">Cancel</b-button>
                                                <b-button class="ml-2 custom-wizard-btn" @click="resetForm()">Reset</b-button>
                                            </div>

                                        </div>
                                    </div>
                                </b-form>

                        </b-overlay>
                    </b-modal>
                </div>


                <div class="col-sm-12  px-0">
                    <b-overlay :show="showoverlay_list" rounded="sm">
                        <table class="table dataTable"> 
                            <thead>
                                <tr class="table-head">

                                    <td>Work Location</td>
                                    <td>IP Address</td>
                                    <td>Port</td>

                                    <td>Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="(device , n) in paginatedData" :key="device.id">


                                    <td class="col-md-3 align-middle">
                                        {{device.branch}}
                                    </td>
                                    <td class="col-md-3 align-middle">
                                        {{device.ip_address}}
                                    </td>
                                    <td class="col-md-3 align-middle">
                                        {{device.port}}
                                    </td>


                                    <td class="clearfix col-md-3 align-middle">
                                        <div class="float-right mr-2 position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <b-icon icon="three-dots-vertical"></b-icon>
                                                </a>
                                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                    <b-button-group>
                                                        <b-button variant="outline-secondary" @click="editDevice(device.id)">
                                                            <b-icon icon="pencil" aria-hidden="true" ></b-icon>Edit
                                                        </b-button>
                                                        <b-button variant="outline-danger" @click="deleteDevice(device.id)">
                                                            <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                        <div v-else class="px-3">
                            <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{devices.length}} records found.</li>
                            </ul>
                            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

                        </div>



                        <div v-if="flg == 1" class="mt-3">
                            <b-button type="button" @click="set_go_next(1)" variant="primary" class="float-right mt-3 mr-3">Go Next</b-button>
                            <b-button type="button" @click="set_go_back(1)" variant="primary" class="float-right mt-3 mr-3">Go Back</b-button>
                            <b-button type="button" @click="setfinish(1)" variant="success" class="float-right mt-3 mx-3">Finish</b-button>
                        </div>

                    </b-overlay>
                </div>



            </div>
        </div>

    </div>
</template>


<script>
    export default{

        mounted() {

        },
        props: ['ce_flg' , 'check_ce' , 'flg'],
        data(){

            return {

                devices:[],
                branches:[],
                errormsg:[],
                fdata: {status:null , id:null, branch_id: null},
                saved_name : '',

                draftdata : {},
                file: null,
                showoverlay:false,
                showoverlay_list:false,
                go_back : false,
                go_next : false,
                finish : false,

                search:'',
                length: 20,
                temp_length:20,
                length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],

                people:0,
                pagination: {currentPage: 1, pages:1},

                successmsg:false,
                warningmsg:false,
                dangermsg:false,

                addtype : false,
                acl:this.$acl,

                modalTitle: 'Add Device',

            }
        },
        methods:{

            showMessage: function()
            {
                let tmp_flg = 0;
                if(this.devices.length > 0)tmp_flg = 1;
                let childdata = {flg:tmp_flg , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg,  move_next:this.go_next , move_back:this.go_back , finish:this.finish};
                this.$emit('childToParent', childdata);
            },
            set_go_back(x){
                this.go_next = false;
                this.go_back = true;
                this.finish = false;

                if(x == 1)
                    this.showMessage();
            },
            set_go_next(x){
                this.go_next = true;
                this.go_back = false;
                this.finish = false;

                if(x == 1)
                    this.showMessage();
            },
            disable_set_go_next(){
                this.go_next = false;
            },
            setfinish(x){
                this.finish = true;

                this.go_next = false;
                this.go_back = false;

                if(x == 1)
                    this.showMessage();
            },


            addNew(x)
            {
                this.modalTitle = 'Add Device';
                this.addtype = x;
                this.resetForm();
                this.$bvModal.show('bv-modal-device');
                //this.newagent = true;
            },
            getDeviceData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/leave-attendance/attendance-device/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.devices = response.data;
                    this.people = this.devices.length;
                    //this.showMessage();

                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            getBranches: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/branch/list').then(function(response){
                    this.branches = response.data;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },


            editDevice:function(id)
            {
                this.addtype = false;

                if(!this.checkNet()) return false;
                this.showoverlay = true;

                let asd = this.devices;

                var item  = asd.find(item => item.id == id);
                this.fdata =item;

                this.modalTitle = 'Edit Device';
                this.$validator.reset();
                this.showoverlay = false;
                this.$bvModal.show('bv-modal-device');
            },


            deleteDevice:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this device.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        this.resetForm();
                        let currentObj = this;
                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/leave-attendance/attendance-device/delete', formData).then(function(response){

                        this.devices = [];
                        this.devices = response.data;
                        this.resetPagination();
                        this.showoverlay_list = false;
                            //this.showMessage();

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.serverError(error);
                        });
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
               this.fdata = {ip_address:null, branch_id:null, port:null, password:null,status:null, id:null};
                this.file = null;
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.warningmsg = null;
                this.successmsg = null;
                //this.showMessage();
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/leave-attendance/attendance-device/save', formData, config)
                                .then(function (response)
                                {
                                    //console.log(response.data);
                                    this.devices = response.data;
                                    this.resetPagination();


                                    this.successmsg = 'Saved!';
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                    this.resetForm();
                                    //this.movenext = true;
                                    //this.showMessage();
                                    this.$bvModal.hide('bv-modal-device');



                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;
                                });
                });
            },

        },
        created: function(){
            this.getDeviceData();
            this.getBranches();
            Fire.$on('reloadUsers', () => {this.getDeviceData()});
        },
        computed:
        {
            filteredData()
            {


                let filtered_list = this.devices;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                }
                return filtered_list;
            },
            paginatedData()
            {

                //console.log(this.length);
                //console.log(this.filteredData);

                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
